import {
  SENS_ACHAT, MODULE_ACHAT, SOUS_TYPE_NORMAL,
  TYPE_COMMANDE,
} from '@/configuration/devisConf';

export default function genererCritereRecherche() {
  return {
    code: '',
    etatsDevisCommandeFacture: [],
    dateFacture: {
      dateDebut: null,
      dateFin: null,
    },
    referenceClient: '',
    auto: '',
    sens: SENS_ACHAT,
    libelle: '',
    tiersId: [],
    produitsIds: [],
    module: MODULE_ACHAT,
    sousTypesDevisCommandeFacture: [SOUS_TYPE_NORMAL],
    typesDevisCommandeFacture: [TYPE_COMMANDE],
  };
}
